import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { findIndex as _findIndex, forEach as _forEach } from 'lodash';
import { Tooltip } from 'react-tooltip';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { connect } from 'react-redux';
import { S3_LINKS } from 'js/constants';
const EditorMediathekFTs = (props) => {
    var _a, _b;
    const { usedMedia, neededHeight, neededWidth, appIntl, intl } = props;
    const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : intl === null || intl === void 0 ? void 0 : intl.messages;
    const handleMedia = useCallback((original, path, filename = '', thumb = '', copyright = '') => {
        props.loadMedia(original, path, filename, thumb, copyright);
    }, [props.loadMedia]);
    const renderMedia = (media, mediaUnavailable, thumbSrc, mediaThumb) => {
        const titleAdd = `<b>Bild:</b> ${media.originalname}<br>` +
            `<b>Dimensionen:</b> ${media.width} x ${media.height} Pixel`;
        return (_jsxs("div", { "data-tooltip-content": titleAdd, "data-html": true, "data-tooltip-id": "mediatop", className: 'medias used_medias ' + mediaUnavailable, onClick: !mediaUnavailable
                ? () => {
                    handleMedia(media.key, S3_LINKS.MEDIA_IMGS_ORIGINAL, media.originalname, media.thumb, media.copyright);
                }
                : undefined, children: [_jsx("div", { className: "thumb", style: mediaThumb }), _jsx("p", { children: media.originalname }), _jsx("p", { children: media.imgDescription || media.img_description })] }, media.key + media.blockid));
    };
    const unusedMedias = [];
    const usedMedias = [];
    const usedImages = [];
    const unusedImages = [];
    const thumbSrc = S3_LINKS.MEDIA_IMGS_THUMB;
    _forEach(usedMedia, (media) => {
        let mediaUnavailable = '';
        if (neededWidth > media.width || neededHeight > media.height) {
            mediaUnavailable = 'disabled';
        }
        const mediaThumb = {
            backgroundImage: `url(${thumbSrc}${media.thumb})`,
        };
        const mediaEntry = renderMedia(media, mediaUnavailable, thumbSrc, mediaThumb);
        const isUsedMedia = media.blockid !== 'unused';
        const isKeyAlreadyUsed = usedImages.includes(media.key);
        const isKeyAlreadyUnused = unusedImages.includes(media.key);
        if (!isUsedMedia && !isKeyAlreadyUnused) {
            const usedMediaEntryIndex = _findIndex(usedMedia, (o) => o.key === media.key && o.blockid !== 'unused');
            if (usedMediaEntryIndex < 0) {
                unusedMedias.push(mediaEntry);
            }
            unusedImages.push(media.key);
        }
        else if (isUsedMedia && !isKeyAlreadyUsed) {
            usedImages.push(media.key);
            if (!isKeyAlreadyUnused) {
                unusedImages.push(media.key);
            }
            usedMedias.push(mediaEntry);
        }
    });
    return (_jsxs("div", { id: "mediathekStage", className: "row col-md-12", children: [_jsx("div", { id: "contextModalMediathek", style: { paddingLeft: '0px' }, className: "col-md-8 text-left", children: _jsx("div", { id: "mediathekMedias", className: "text-center" }) }), _jsxs("div", { id: "contextModalUsedMedia", className: "col-md-12 text-left", children: [_jsx("h4", { style: { margin: '0 auto', marginBottom: '20px' }, children: messages.editor.document_pictures }), _jsxs("div", { id: "usedMedias", className: "text-center", children: [_jsx("h5", { children: messages.editor.used_images }), usedMedias] }), _jsxs("div", { id: "unusedMedias", className: "text-center", children: [_jsx("h5", { children: messages.editor.unused_images }), unusedMedias] })] }), _jsx(Tooltip, { id: "mediatop", place: "top" })] }));
};
const mapStateToProps = (state) => {
    return {
        appIntl: state.intl,
    };
};
export default withRouter(connect(mapStateToProps)(legacyInjectIntl(EditorMediathekFTs)));
